import React , { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router  } from 'react-router-dom';
import 'normalize.css';
import './index.css';
import "@fontsource/plus-jakarta-sans";
import "@fontsource/manrope"; 
import App from './App';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const LoadingSpinner = () => (
  <div className='fixed inset-0 w-full h-screen flex justify-center items-center bg-white z-[99999]'>
    <AiOutlineLoading3Quarters className='animate-spin text-6xl text-primary'/>
  </div>
);
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
   <Suspense fallback={<LoadingSpinner />}>
      <Router>
          <App />
      </Router>
    </Suspense>
  </React.StrictMode>
);

